import { createFileRoute } from "@tanstack/react-router";
import TossavondOrganiseren from "@/pages/TossavondOrganiseren";

export const Route = createFileRoute("/tossavond-organiseren")({
  head: () => ({
    meta: [
      { title: "Tossavond organiseren bij je tennisclub | De Hussel- en Toss App" },
      { name: "description", content: "Organiseer eenvoudig een tossavond bij je tennisclub. Slimme automatische indeling op basis van niveau, gespeelde rondes en tegenstanders. Geen tossleider nodig." },
      { property: "og:title", content: "Tossavond organiseren bij je tennisclub | De Hussel- en Toss App" },
      { property: "og:description", content: "Organiseer eenvoudig een tossavond bij je tennisclub. Slimme automatische indeling op basis van niveau, gespeelde rondes en tegenstanders. Geen tossleider nodig." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tossavond-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tossavond-organiseren" }],
  }),
  component: TossavondOrganiseren,
});
